const ICON_BASE = "/img/new-icons/external-food";

export const EXTERNAL_FOOD_MEAL_TYPE_ORDER = [
  { value: "breakfast", id: "breakfast", icon: `${ICON_BASE}/breakfast.svg` },
  { value: "main course", id: "mainCourse", icon: `${ICON_BASE}/maincourse.svg` },
  { value: "soup", id: "soup", icon: `${ICON_BASE}/soup.svg` },
  { value: "salad", id: "salad", icon: `${ICON_BASE}/salad.svg` },
  { value: "snack", id: "snack", icon: `${ICON_BASE}/snack.svg` },
  { value: "appetizer", id: "appetizer", icon: `${ICON_BASE}/appetizer.svg` },
  { value: "side dish", id: "sideDish", icon: `${ICON_BASE}/sidedish.svg` },
  { value: "dessert", id: "dessert", icon: `${ICON_BASE}/dessert.svg` },
  { value: "fingerfood", id: "fingerfood", icon: `${ICON_BASE}/fingerfood.svg` },
  { value: "bread", id: "bread", icon: `${ICON_BASE}/bread.svg` },
  { value: "beverage", id: "beverage", icon: `${ICON_BASE}/beverages.svg` },
  { value: "drink", id: "drink", icon: `${ICON_BASE}/drink.svg` },
  { value: "sauce", id: "sauce", icon: `${ICON_BASE}/sauce.svg` },
  { value: "marinade", id: "marinade", icon: `${ICON_BASE}/marinade.svg` },
];

export const EXTERNAL_FOOD_MEAL_TYPE_ALL = {
  value: "",
  id: "all",
  icon: `${ICON_BASE}/all.svg`,
};

const CONFIG_BY_VALUE = new Map(
  EXTERNAL_FOOD_MEAL_TYPE_ORDER.map((item) => [item.value, item]),
);

function mealTypeId(value) {
  return String(value)
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
}

export function buildExternalFoodMealTypeItems(mealTypesFromApi) {
  const items = [EXTERNAL_FOOD_MEAL_TYPE_ALL];

  if (!Array.isArray(mealTypesFromApi)) {
    return [EXTERNAL_FOOD_MEAL_TYPE_ALL, ...EXTERNAL_FOOD_MEAL_TYPE_ORDER];
  }

  const seen = new Set();

  for (const config of EXTERNAL_FOOD_MEAL_TYPE_ORDER) {
    if (!mealTypesFromApi.includes(config.value)) continue;
    items.push(config);
    seen.add(config.value);
  }

  for (const value of mealTypesFromApi) {
    if (seen.has(value)) continue;
    const known = CONFIG_BY_VALUE.get(value);
    items.push({
      value,
      id: (known?.id ?? mealTypeId(value)) || "all",
      icon: known?.icon ?? EXTERNAL_FOOD_MEAL_TYPE_ALL.icon,
      fallbackLabel: !known,
    });
  }

  return items;
}
